import React, { useState } from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { DashboardItemValidation } from 'app/area/dashboard-administration/form/types-store';
import { SavedReportDashboard } from 'app/area/dashboard-administration/common/types-store';
import { PopupAddNewSelect } from 'app/area/shared/list-components/popup-add-new-select';

export interface PopupAddReportsProps {
  title: string;
  actionTitle?: string;
  currentSavedReport: SavedReportDashboard;
  selectedValues?: ComplexValue<number>[];
  options: ComplexValue<number>[];
  fetchingOptions: boolean;
  descriptionAllLevels: boolean;
  doneLabel: string;
  searchPlaceholder: string;
  locale: string;
  validation: DashboardItemValidation;

  loadOptions: (loadOptionsParams: LoadOptions) => void;
  onAction?: () => void;
  addItems: (options: ComplexValue<number>[], currentSavedReport: SavedReportDashboard) => void;
  onClose: () => void;
}

export const PopupAddReports: React.FC<PopupAddReportsProps> = ({
  title, actionTitle, currentSavedReport,
  selectedValues, options, fetchingOptions,
  descriptionAllLevels, doneLabel, searchPlaceholder, locale,
  loadOptions, onAction, addItems, onClose
}) => {

  const [valueItems, setValueItems] = useState<ComplexValue<number>[]>(selectedValues ?? []);

  const handleAddReports = () => {
    addItems(valueItems, currentSavedReport);
    setValueItems([]);
  };

  const isDisabled = valueItems.length === 0;

  return <ModalWrapper
    headerTitle={title}
    btnTitle={doneLabel}
    btnExtraFooterActionTitle={actionTitle}
    onExtraFooterAction={onAction}
    onClose={onClose}
    onDone={handleAddReports}
    isDisabled={isDisabled}
    isExtraFooterActionDisabled={false}>
    <PopupAddNewSelect
      valueItems={valueItems}
      onChange={setValueItems}
      options={options}
      fetchingOptions={fetchingOptions}
      loadOptions={loadOptions}
      descriptionAllLevels={descriptionAllLevels}
      searchPlaceholder={searchPlaceholder}
      locale={locale}
    />
  </ModalWrapper>;
};
